import { z } from 'zod';
import { zDateRequired, zStringRequired } from '../z';
export const medicationTeachingSchema = z.object({
    id: z.string().optional(),
    medicationId: zStringRequired(),
    type: zStringRequired(),
    date: zDateRequired(),
    notes: z.string().nullish(),
});
